import { render } from "./TaskRow.vue?vue&type=template&id=081d7cd2&scoped=true"
import script from "./TaskRow.vue?vue&type=script&lang=js"
export * from "./TaskRow.vue?vue&type=script&lang=js"

import "./TaskRow.vue?vue&type=style&index=0&id=081d7cd2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-081d7cd2"

export default script